import Document from '@advisor/models/store/settings/documents/Document';

export default class Documents {
  constructor() {
    this.documents = [];
    this.currentDocument = new Document();
  }
}
